var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriterionLogoMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 25 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5406C1 9.29901 2.72632 7.48183 4.85584 7.48183H14.7364C16.8659 7.48183 18.5923 9.29901 18.5923 11.5406V21.9412C18.5923 24.1828 16.8659 26 14.7364 26H4.85584C2.72632 26 1 24.1828 1 21.9412V11.5406Z",
    fill: "white",
    fillOpacity: 0.83
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48047 5.05878C7.48047 2.81718 9.20679 1 11.3363 1H21.2169C23.3464 1 25.0727 2.81718 25.0727 5.05878V15.4594C25.0727 17.701 23.3464 19.5182 21.2169 19.5182H11.3363C9.20679 19.5182 7.48047 17.701 7.48047 15.4594V5.05878Z",
    fill: "#06AEEF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriterionLogoMini);
export default __webpack_public_path__ + "static/media/criterion-logo-mini.dd181d35b12111d2bc954ae7d94e98ed.svg";
export { ForwardRef as ReactComponent };